export default Object.freeze({
  WorkplaceRegisterExportFlag:
    'R2B_Web_SelfService_EnableWorkplaceRegisterExport',
  SelfServiceReleaseBookable: 'R2B_SelfService_ReleaseBookable',
})
